import React from "react";
import { Menu, MenuItemLink, useResourceDefinitions } from "react-admin";
import DefaultIcon from "@mui/icons-material/ViewList";
import BuildIcon from "@mui/icons-material/Build";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CropFreeIcon from "@mui/icons-material/CropFree";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import MenuItem from "@mui/material/MenuItem";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import StorefrontIcon from "@mui/icons-material/Storefront";
import WorkIcon from "@mui/icons-material/Work";
import { Feedback } from "@mui/icons-material";
import { Star } from "@mui/icons-material";

import SubMenu from "./SubMenu";
import { useSubscription } from "../DataHooks/useSubscription";
import { useIsSuperAdminMode } from "../DataHooks/superAdminMode";

const MyMenu = ({ onMenuClick, logout }) => {
  const { isPlanValid } = useSubscription();
  const isSuperAdmin = useIsSuperAdminMode();
  const resourcesDefinitions = useResourceDefinitions();
  const [state, setState] = React.useState({
    menuOrders: true,
    menuWebstore: true,
    menuExtra: true,
  });
  const resources = Object.keys(resourcesDefinitions).map(
    (name) => resourcesDefinitions[name]
  );

  const ordersResources = resources.filter((r) => r.name.includes("orders"));
  // const contactResource = resources.find((r) => r.name === "contacts");
  // const orderItemResource = resources.find((r) => r.name === "orderItems");
  // const paymentResource = resources.find((r) => r.name === "payments");
  // const keywordResource = resources.find((r) => r.name === "keywords");
  // const creditLogsResource = resources.find((r) => r.name === "creditlogs");

  const webstoreResources = resources.filter(
    (r) =>
      r.name.includes("variants") ||
      r.name.includes("selections") ||
      r.name.includes("categories")
  );
  const extraResources = resources.filter(
    (r) =>
      r.name.includes("tags") ||
      r.name.includes("vouchers") ||
      r.name.includes("waitlists") ||
      r.name.includes("exports")
  );

  if (!isPlanValid && !isSuperAdmin) {
    return (
      <div>
        <MenuItemLink
          to={`/`}
          primaryText="Dashboard"
          onClick={onMenuClick}
          leftIcon={<DashboardIcon />}
        />
      </div>
    );
  }

  const handleToggle = (menu) => {
    setState((state) => ({ ...state, [menu]: !state[menu] }));
  };

  return (
    <Menu>
      <Menu.DashboardItem />
      <MenuItemLink
        to={`/analytics`}
        primaryText="Analytics"
        onClick={onMenuClick}
        leftIcon={<ShowChartIcon />}
      />
      <Menu.ResourceItem name="contacts" />
      <SubMenu
        handleToggle={() => handleToggle("menuOrders")}
        isOpen={state.menuOrders}
        name={`resources.orders.name`}
        icon={<AttachMoneyIcon />}
        //dense={dense}
      >
        {ordersResources.map((resource, idx) => (
          <Menu.ResourceItem
            name={`${resource.name}`}
            key={`${idx}${resource.name}`}
          />
        ))}
      </SubMenu>
      <Menu.ResourceItem name="payments" />
      <Menu.ResourceItem name="orderItems" />
      <Menu.ResourceItem name="keywords" />
      <SubMenu
        handleToggle={() => handleToggle("menuWebstore")}
        isOpen={state.menuWebstore}
        name={`resources.webstore.name`}
        icon={<StorefrontIcon />}
        //dense={dense}
      >
        {webstoreResources.map((resource, idx) => (
          <Menu.ResourceItem
            name={`${resource.name}`}
            key={`${idx}${resource.name}`}
          />
        ))}
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle("menuExtra")}
        isOpen={state.menuExtra}
        name={`resources.others.name`}
        icon={<WorkIcon />}
        //dense={dense}
      >
        {extraResources.map((resource, idx) => (
          <Menu.ResourceItem
            name={`${resource.name}`}
            key={`${idx}${resource.name}`}
          />
        ))}
      </SubMenu>
      <MenuItemLink
        to={`/special-tools`}
        primaryText={`resources.tools.name`}
        onClick={onMenuClick}
        leftIcon={<BuildIcon />}
      />
      <Menu.ResourceItem name="creditlogs" />
      <MenuItemLink
        to={`/qr-scanner`}
        primaryText="QR scan"
        onClick={onMenuClick}
        leftIcon={<CropFreeIcon />}
      />
      <MenuItemLink
        component="a"
        to="#"
        href="https://docs.google.com/document/d/e/2PACX-1vT2eg15RJ70OjKvcw70VPL83N-2AgKQYZXNI1O-ovcrlGjJoPRu3TRPwdwUnAnI0lHAwkEkD74COb1_/pub"
        primaryText="Reward Program"
        leftIcon={<Star />}
        target="_blank"
        rel="noopener noreferrer"
      />
      <MenuItemLink
        component="a"
        to="#"
        href="https://forms.gle/bcqo2HncMHWX7d828"
        primaryText="Feature Request"
        leftIcon={<Feedback />}
        target="_blank"
        rel="noopener noreferrer"
      />
    </Menu>
  );
};

export default MyMenu;
